import {forwardRef} from 'react';

import {Icon} from '#component/base/Icon';
import {Text} from '#component/base/Text';
import {sprinkles} from '#style/sprinkles';

import * as css from './Alert.css';

/**
 * An alert displays a short, important message in a way that attracts the
 * user's attention without interrupting the user's task.
 */
export const Alert = forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>(
  ({children, className, ...otherProps}, ref) => (
    <div className={[css.root, className || ''].join(' ')} {...otherProps} ref={ref} role="alert">
      <Icon aria-hidden className={sprinkles({shrink: 0})} color="solidRed" name="WarningCircle" />
      <Text as="p">{children}</Text>
    </div>
  ),
);
